import React from 'react';
import { Switch } from 'react-router-dom';
import LoadableRoute from '../components/features/share/loadable/loadableRoute';
import {
    AdminCarReservationPrivateRoute,
    AdminPrivateRoute,
    AdminTrackerPrivateRoute,
    AdminTrainingPrivateRoute,
    DriverPrivateRoute,
    PrivateRoute,
    PublicRoute
} from './routePermission';

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster')
});
const layoutLogin = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutLogin')
});
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank')
});
const LayoutWithMenu = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutWithMenu')
});
const LayoutTracker = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutTracker')
});
const LayoutCar = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutCar')
});

//Features

// const TrackerController = LoadableRoute({
//     loader: () => import('../components/features/tracker/home/controllers/trackerController'),
// })
//Auth
const Login = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController')
});
const bypassLoginController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/bypassLoginController')
});

const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController')
});
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController')
});
const LogoutController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/logoutController')
});

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/tracker/home/controllers/homeController')
});
const TrackerHomeController = LoadableRoute({
    loader: () => import('../components/features/trackerTailwind/home/controllers/homeController')
});

// Info
const InfoController = LoadableRoute({
    loader: () => import('../components/features/tracker/info/controllers/infoController')
});

// Task List
const TaskListController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/list/controllers/taskListController')
});

const MyTaskListController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/list/controllers/myTaskListController')
});
const MyTaskListNewController = LoadableRoute({
    loader: () => import('../components/features/trackerTailwind/trakerNew/tracker/taskList/list/controllers/myTaskListController')
});

const MyDraftListController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/list/controllers/myDraftListController')
});

// Create Task
const CreateTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/create/controllers/createTaskController')
});

// View Draft Task
const ViewDraftTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/view/controllers/viewDraftTaskController')
});

// View My Task
const ViewMyTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/view/controllers/viewMyTaskController')
});
// const ViewMyTaskController = LoadableRoute({
//     loader: () => import('../components/features/trackerTailwind/trakerNew/tracker/taskList/view/controllers/viewMyTaskController')
// });

// View Assign Task
const ViewAssignTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/view/controllers/viewAssignTaskController')
});

// Comment Controller
const CommentController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/comment/controllers/commentController')
});

// User Info
const UserInfoController = LoadableRoute({
    loader: () => import('../components/features/tracker/userinfo/controllers/userController')
});
const UserInfoNewController = LoadableRoute({
    loader: () => import('../components/features/trackerTailwind/home/controllers/userNewController.js')
});

// Update OilPrice
const UpdateOilPRiceController = LoadableRoute({
    loader: () => import('../components/features/tracker/oilPrice/controllers/realtimeOilPrice')
});

// UpdateTask Controller
const UpdateTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/update/controllers/updateController')
});

const PrompayQRController = LoadableRoute({
    loader: () => import('../components/features/prompayQR/controllers/prompayQRController')
});

//Settings

const MasterDataController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/landingMenu/controllers/masterDataController')
});
const TrainingMasterDataController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/landingMenu/controllers/trainingMasterDataController')
});
const Calendar = LoadableRoute({
    loader: () => import('../components/features/carReserveTailwind/reserve/controllers/calendarController')
    // loader: () => import('../components/features/carReserveTailwind/reserve/controllers/listCarReserveController')
});
const CarReserve = LoadableRoute({
    loader: () => import('../components/features/carReserveTailwind/reserve/controllers/listCarReserveController')
});
const TrackerCreate = LoadableRoute({
    loader: () => import('../components/features/trackerTailwind/home/controllers/trackerInitNewController')
});
const TrackerList = LoadableRoute({
    loader: () => import('../components/features/trackerTailwind/home/controllers/trackerListcontroller')
});
const TrackerListHistory = LoadableRoute({
    loader: () => import('../components/features/trackerTailwind/home/controllers/trackerListHistorycontroller')
});
const TrackerHistory = LoadableRoute({
    loader: () => import('../components/features/trackerTailwind/home/controllers/trackerLnitNewHistoryController.js')
});
const DriverReserve = LoadableRoute({
    loader: () => import('../components/features/carReserveTailwind/reserve/controllers/driverController')
});
const CarReserveMasterDataController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/landingMenu/controllers/carReserveMasterDataController')
});
const ReportController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/landingMenu/controllers/reportController')
});
// User Group
const ListUserGroupController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/userGroup/controllers/listUserGroupsController')
});

const CreateUserGroupController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/userGroup/controllers/createUserGroupsController')
});

const UpdateUserGroupController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/userGroup/controllers/updateUserGroupsController')
});

const ViewUserGroupController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/userGroup/controllers/viewUserGroupsController')
});

// Admin User Group
const ListAdminUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/listUserGroupsController')
});
// const NewListUserGroupController = LoadableRoute({
//     loader: () => import('../components/features/settings/admin/userGroup/controllers/NewlistUserGroupController')
// });
const NewListUserGroupController2 = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/NewlistUserGroupController')
});

const CreateAdminUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/createUserGroupsController')
});

const UpdateAdminUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/updateUserGroupsController')
});

const ViewAdminUserGroupController = LoadableRoute({
    loader: () => import('../components/features/settings/admin/userGroup/controllers/viewUserGroupsController')
});

// Flow
const ListFlowController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/flow/controllers/listFlowsController')
});

const CreateFlowController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/flow/controllers/createFlowsController')
});

const UpdateFlowController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/flow/controllers/updateFlowsController')
});

const ViewFlowController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/flow/controllers/viewFlowsController')
});

// Course Type
const ListCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/courseType/controllers/listCourseTypeController')
});

const CreateCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/courseType/controllers/createCourseTypeController')
});

const UpdateCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/courseType/controllers/updateCourseTypeController')
});

const ViewCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/courseType/controllers/viewCourseTypeController')
});

// Course

const ListCourseWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseWaitingApproveController')
});

const DetailCourseWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/detailCourseWaitingApproveController')
});

const ListCourseWaitingRequestController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseWaitingRequestController')
});

const DetailCourseWaitingRequestController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/detailCourseWaitingRequestController')
});

const ScoreCertCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/scoreCertCourseController')
});

const ListCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseController')
});

const CreateCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/createCourseController')
});

const UpdateCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/updateCourseController')
});

const ViewCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/viewCourseController')
});

// Course History

const ListCourseHistoryWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseHistoryWaitingApproveController')
});

const DetailCourseHistoryWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/detailCourseHistoryWaitingApproveController')
});

const ScoreCertCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/scoreCertCourseHistoryController')
});

const ListCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseHistoryController')
});

const CreateCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/createCourseHistoryController')
});

const UpdateCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/updateCourseHistoryController')
});

const ViewCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/viewCourseHistoryController')
});

// Landing Page for Hr Module
const HrModuleHome = LoadableRoute({
    loader: () => import('../components/features/hr/home/controllers/hrModuleHomeController')
});

const MyCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/myCourse/controllers/listMyCourseController')
});

const MyCertController = LoadableRoute({
    loader: () => import('../components/features/hr/myCert/controllers/listMyCertController')
});

//Report
const ReportCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/report/controllers/reportCourseController')
});

//Report
const ReportCarReserveController = LoadableRoute({
    loader: () => import('../components/features/carReserve/report/reportCarReserveController')
});

// Car Reservervation
// Car Type
const ListCarTypeController = LoadableRoute({
    loader: () => import('../components/features/carReserveTailwind/MaterDatas/carType/list/controllers/listCarTypeController')
});

const CreateCarTypeController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/carType/create/controllers/createCarTypeController')
});

const UpdateCarTypeController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/carType/update/controllers/updateCarTypeController')
});

const ViewCarTypeController = LoadableRoute({
    loader: () => import('../components/features/carReserveTailwind/MaterDatas/carType/view/controllers/viewCarTypeController')
});
// User Group
const ListCarRUserGroupController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/userGroup/controllers/listUserGroupsController')
});

const CreateCarRUserGroupController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/userGroup/controllers/createUserGroupsController')
});

const UpdateCarRUserGroupController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/userGroup/controllers/updateUserGroupsController')
});

const ViewCarRUserGroupController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/userGroup/controllers/viewUserGroupsController')
});
// Car
const ListRCarController = LoadableRoute({
    loader: () => import('../components/features/carReserveTailwind/MaterDatas/Car/list/controllers/listCarController')
});

const CreateRCarController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/car/create/controllers/createCarController')
});

const UpdateRCarController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/car/update/controllers/updateCarController')
});

const ViewRCarController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/car/view/controllers/viewCarController')
});
// Car Driver
const GetCarDriverController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/carDriver/view/controllers/getCarDriverControllerReUi')
});
const UpdateCarDriverController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterdata/carDriver/update/controllers/updateCarDriverControllerReUi')
});

// Car Reserve
const CarReserveController = LoadableRoute({
    loader: () => import('../components/features/carReserve/reserve/controllers/listCarReserveController')
});

const CarReserveHistoryController = LoadableRoute({
    loader: () => import('../components/features/carReserve/reserve/controllers/historyCarReserveController')
});

const CreateCarReserveController = LoadableRoute({
    loader: () => import('../components/features/carReserve/reserve/controllers/createCarReserveController')
});

const UpdateCarReserveController = LoadableRoute({
    loader: () => import('../components/features/carReserve/reserve/controllers/updateCarReserveController')
});

const ViewCarReserveController = LoadableRoute({
    loader: () => import('../components/features/carReserve/reserve/controllers/viewCarReserveController')
});

const HistoryApproveCarReserveController = LoadableRoute({
    loader: () => import('../components/features/carReserve/reserveApprove/controllers/historyReserveApproveControllers')
});
const ApproveCarReserveController = LoadableRoute({
    // loader: () => import('../components/features/carReserve/reserveApprove/controllers/reserveApproveControllers')
    loader: () => import('../components/features/carReserveTailwind/MaterDatas/ManageReserve/Controllers/ManageReserveController')
});
const ApproveCarReserveControllerVOld = LoadableRoute({
    loader: () => import('../components/features/carReserve/reserveApprove/controllers/reserveApproveControllers')
    // loader: () => import('../components/features/ManageReserve/Controllers/ManageReserveController')
});

const DetailApproveCarReserveController = LoadableRoute({
    loader: () => import('../components/features/carReserve/reserveApprove/controllers/detailReserveApproveControllers')
});

const DriverJobListController = LoadableRoute({
    loader: () => import('../components/features/carReserve/driver/jobList/controllers/listJobListController')
});

const DetailDriverJobListController = LoadableRoute({
    loader: () => import('../components/features/carReserve/driver/detail/controllers/detailDriverJobListController')
});

const CalendarTest = LoadableRoute({
    loader: () => import('../components/features/test/calendar/calendarController')
});

const CalendarTest2 = LoadableRoute({
    loader: () => import('../components/features/test/calendar/testCAl')
});

const ProjectManagementController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/controllers/pmController')
});
const MyProjectController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/controllers/listMyProjectController')
});
const CreateProjectController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/controllers/createProjectController')
});

const ViewProjectController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/controllers/viewProjectController')
});
const UpdateProjectController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/controllers/updateProjectController')
});

const AddTimeSheetProjectController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/controllers/timesheetProjectController')
});

//Backend

const ListCustomerController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/masterData/customer/controllers/listCustomerController')
});

const CreateCustomerController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/masterData/customer/controllers/createCustomerController')
});

const UpdateCustomerController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/masterData/customer/controllers/updateCustomerController')
});

const ViewCustomerController = LoadableRoute({
    loader: () => import('../components/features/projectManagement/masterData/customer/controllers/viewCustomerController')
});
const Projects = LoadableRoute({
    loader: () => import('../components/features/projects/controllers/projectController')
});
const ProjectDetail = LoadableRoute({
    loader: () => import('../components/features/projects/controllers/projectDetailController')
});
export default () => (
    <Switch>
        {/* Level 7*/}
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/history/view/:id/:active"
            component={ViewCourseHistoryController}
            layout={LayoutMaster}
        />

        {/* Level 6 */}
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/history/view/:id"
            component={ViewCourseHistoryController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/history/update/:id"
            component={UpdateCourseHistoryController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/history/scoreCert/:id"
            component={ScoreCertCourseHistoryController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/history/waitingapprove/:id"
            component={DetailCourseHistoryWaitingApproveController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute path="/training/masterdata/course/view/:id/:active" component={ViewCourseController} layout={LayoutMaster} />

        {/* Level 5 */}
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/car/view/:id" component={ViewRCarController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/car/update/:id" component={UpdateRCarController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute
            path="/carReserve/masterdata/userGroup/view/:id"
            component={ViewCarRUserGroupController}
            layout={LayoutMaster}
        />
        <AdminCarReservationPrivateRoute
            path="/carReserve/masterdata/userGroup/update/:id"
            component={UpdateCarRUserGroupController}
            layout={LayoutMaster}
        />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/carType/view/:id" component={ViewCarTypeController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/carType/update/:id" component={UpdateCarTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/course/update/:id" component={UpdateCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/course/view/:id" component={ViewCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/course/scoreCert/:id" component={ScoreCertCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/waitingrequest/:id"
            component={DetailCourseWaitingRequestController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/waitingapprove/:id"
            component={DetailCourseWaitingApproveController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/history/waitingapprove"
            component={ListCourseHistoryWaitingApproveController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/history/create"
            component={CreateCourseHistoryController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute path="/training/masterdata/coursetype/update/:id" component={UpdateCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/coursetype/view/:id" component={ViewCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/flow/update/:id" component={UpdateFlowController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/flow/view/:id" component={ViewFlowController} layout={LayoutMaster} />

        {/* Level 4 */}
        <AdminPrivateRoute path="/project/setting/customers/view/:id" component={ViewCustomerController} layout={LayoutWithMenu} />
        <AdminPrivateRoute path="/project/setting/customers/update/:id" component={UpdateCustomerController} layout={LayoutWithMenu} />
        <AdminCarReservationPrivateRoute path="/car/reserve/approve/history" component={HistoryApproveCarReserveController} layout={LayoutCar} />
        <PrivateRoute path="/car/reserve/approve/:id" component={DetailApproveCarReserveController} layout={LayoutCar} />
        <PrivateRoute path="/car/reserve/view/:id" component={ViewCarReserveController} layout={LayoutCar} />
        <PrivateRoute path="/car/reserve/update/:id" component={UpdateCarReserveController} layout={LayoutCar} />
        <AdminCarReservationPrivateRoute
            path="/carReserve/masterdata/carDriver/update"
            component={UpdateCarDriverController}
            layout={LayoutWithMenu}
        />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/car/create" component={CreateRCarController} layout={LayoutWithMenu} />
        <AdminCarReservationPrivateRoute
            path="/carReserve/masterdata/userGroup/create"
            component={CreateCarRUserGroupController}
            layout={LayoutMaster}
        />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/carType/create" component={CreateCarTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/course/create" component={CreateCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/waitingrequest"
            component={ListCourseWaitingRequestController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute
            path="/training/masterdata/course/waitingapprove"
            component={ListCourseWaitingApproveController}
            layout={LayoutMaster}
        />
        <AdminTrainingPrivateRoute path="/training/masterdata/coursetype/create" component={CreateCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/flow/create" component={CreateFlowController} layout={LayoutMaster} />
        <AdminPrivateRoute path="/masterdata/usergroupsadmin/update/:id" component={UpdateAdminUserGroupController} layout={LayoutWithMenu} />
        <AdminTrackerPrivateRoute path="/masterdata/usergroups/update/:id" component={UpdateUserGroupController} layout={LayoutMaster} />
        <AdminPrivateRoute path="/masterdata/usergroupsadmin/view/:id" component={ViewAdminUserGroupController} layout={LayoutWithMenu} />
        <AdminTrackerPrivateRoute path="/masterdata/usergroups/view/:id" component={ViewUserGroupController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/course/history" component={ListCourseHistoryController} layout={LayoutMaster} />

        {/* Level 3 */}
        <AdminPrivateRoute path="/project/setting/customers/create" component={CreateCustomerController} layout={LayoutWithMenu} />
        <PrivateRoute path="/car/reserve/history" component={CarReserveHistoryController} layout={LayoutCar} />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/carDriver" component={GetCarDriverController} layout={LayoutWithMenu} />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/Car" component={ListRCarController} layout={LayoutWithMenu} />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/userGroup" component={ListCarRUserGroupController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path="/carReserve/masterdata/carType" component={ListCarTypeController} layout={LayoutWithMenu} />
        <DriverPrivateRoute path="/car/driver/:id" component={DetailDriverJobListController} layout={LayoutCar} />
        <PrivateRoute path="/car/reserve/approve" component={ApproveCarReserveController} layout={LayoutWithMenu} />
        {/* <PrivateRoute path="/car/reserve/approve/old" component={ApproveCarReserveControllerVOld} layout={LayoutWithMenu} /> */}
        <PrivateRoute path="/car/reserve/create" component={CreateCarReserveController} layout={LayoutCar} />
        <AdminTrainingPrivateRoute path="/training/masterdata/course" component={ListCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/coursetype" component={ListCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path="/training/masterdata/flow" component={ListFlowController} layout={LayoutMaster} />
        <PrivateRoute path="/comment/:taskM/:id" component={CommentController} layout={LayoutWithMenu} />
        <PrivateRoute path="/draft/view/:id" component={ViewDraftTaskController} layout={LayoutTracker} />
        <PrivateRoute path="/mytask/view/:id" component={ViewMyTaskController} layout={LayoutWithMenu} />
        <PrivateRoute path="/assingtask/view/:id" component={ViewAssignTaskController} layout={LayoutTracker} />
        <PrivateRoute path="/pm/view/:id" component={ViewProjectController} layout={layoutLogin} />
        <PrivateRoute path="/pm/timesheet/:id" component={AddTimeSheetProjectController} layout={layoutLogin} />
        <PrivateRoute path="/pm/update/:id" component={UpdateProjectController} layout={layoutLogin} />

        <AdminPrivateRoute path="/masterdata/usergroupsadmin/create" component={CreateAdminUserGroupController} layout={LayoutWithMenu} />
        <AdminTrackerPrivateRoute path="/masterdata/usergroups/create" component={CreateUserGroupController} layout={LayoutMaster} />
        <AdminPrivateRoute path="/project/setting/customers" component={ListCustomerController} layout={LayoutWithMenu} />

        {/* Level 2 */}
        <DriverPrivateRoute path="/car/driver" component={DriverJobListController} layout={LayoutCar} />
        <PrivateRoute path="/car/reserve" component={CarReserveController} layout={LayoutCar} />
        {/* <AdminPrivateRoute path="/masterdata/usergroupsadmin" component={ListAdminUserGroupController} layout={LayoutWithMenu} /> */}
        <AdminPrivateRoute path="/masterdata/usergroupsadmin" component={NewListUserGroupController2} layout={LayoutWithMenu} />
        <AdminTrackerPrivateRoute path="/masterdata/usergroups" component={ListUserGroupController} layout={LayoutMaster} />
        <PrivateRoute path="/task/create" component={CreateTaskController} layout={LayoutTracker} />
        <PrivateRoute path="/update/:id" component={UpdateTaskController} layout={LayoutWithMenu} />
        <PrivateRoute exact path="/crshome/myCourse" component={MyCourseController} layout={LayoutTracker} />
        <PrivateRoute exact path="/crshome/history" component={MyCertController} layout={LayoutTracker} />
        <PrivateRoute path="/report/carReserve" component={ReportCarReserveController} layout={LayoutWithMenu} />
        <PrivateRoute path="/report/course" component={ReportCourseController} layout={LayoutMaster} />
        <PrivateRoute exact path="/carReserve/masterdata" component={CarReserveMasterDataController} layout={LayoutWithMenu} />
        <PrivateRoute exact path="/training/masterdata" component={TrainingMasterDataController} layout={LayoutMaster} />
        <PrivateRoute exact path="/pm/myProject" component={MyProjectController} layout={layoutLogin} />
        <PrivateRoute path="/carReserves/calendar" component={Calendar} layout={LayoutWithMenu} />
        <PrivateRoute exact path="/pm/create" component={CreateProjectController} layout={layoutLogin} />
        <PrivateRoute path="/project/:id" component={ProjectDetail} layout={LayoutWithMenu} />

        {/* Level 1 */}
        <PrivateRoute path="/logout" component={LogoutController} layout={LayoutBlank} />
        <PrivateRoute path="/report" component={ReportController} layout={LayoutMaster} />
        <PrivateRoute exact path="/masterdata" component={MasterDataController} layout={LayoutMaster} />
        <PrivateRoute path="/info" component={InfoController} layout={LayoutTracker} />
        <PrivateRoute path="/userinfo" component={UserInfoController} layout={LayoutTracker} />
        <PrivateRoute path="/draft" component={MyDraftListController} layout={LayoutTracker} />
        <PrivateRoute path="/mytask" component={MyTaskListController} layout={LayoutTracker} />
        <PrivateRoute path="/tasklist" component={TaskListController} layout={LayoutTracker} />
        <PrivateRoute path="/oil" component={UpdateOilPRiceController} layout={LayoutTracker} />
        <PrivateRoute path="/projects" component={Projects} layout={LayoutWithMenu} />
        <PrivateRoute path="/trackernew" component={TrackerCreate} layout={LayoutWithMenu} />
        <PrivateRoute path="/trackerlist" component={TrackerList} layout={LayoutWithMenu} />
        <PrivateRoute path="/listHistory" component={TrackerListHistory} layout={LayoutWithMenu} />
        <PrivateRoute path="/trackerHistory" component={TrackerHistory} layout={LayoutWithMenu} />
        <PrivateRoute path="/profile" component={UserInfoNewController} layout={LayoutWithMenu} />
        <PrivateRoute path="/carReserves" component={CarReserve} layout={LayoutWithMenu} />
        <PrivateRoute path="/formydriver" component={DriverReserve} layout={LayoutWithMenu} />
        {/* <PublicRoute exact path='/' component={HomeController} layout={LayoutTracker} /> */}
        <PrivateRoute exact path="/calendar2" component={CalendarTest2} layout={LayoutMaster} />
        <PrivateRoute exact path="/calendar" component={CalendarTest} layout={LayoutMaster} />
        <PrivateRoute exact path="/crshome" component={HrModuleHome} layout={LayoutBlank} />
        <PrivateRoute exact path="/prompayqr" component={PrompayQRController} layout={LayoutTracker} />

        <PrivateRoute exact path="/pm" component={ProjectManagementController} layout={LayoutMaster} />
        {/* <PrivateRoute exact path='/tckhome' component={TrackerController} layout={LayoutTracker} /> */}
        <PrivateRoute exact path="/tracker" component={HomeController} layout={LayoutWithMenu} />
        <PrivateRoute exact path="/home" component={HomeController} layout={LayoutWithMenu} />
        <PrivateRoute exact path="/" component={HomeController} layout={LayoutWithMenu} />

        <PublicRoute path="/unauthen" component={UnAuthenController} layout={LayoutBlank} />
        <PublicRoute path="/login" component={Login} layout={layoutLogin} />
        <PublicRoute path="/bypass/:base64" component={bypassLoginController} layout={LayoutBlank} />

        <PublicRoute component={NotFoundController} />
    </Switch>
);



// WEBPACK FOOTER //
// ./src/app/routes/Routes.js